/* eslint-disable react/jsx-props-no-spreading */
import { UserPermissions, UserType } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import { IconProps } from 'Icons/IconProps';
import React from 'react';
import { RiKey2Line } from 'react-icons/ri';
import { LoadingContent } from 'Shared/PageElements';
import { LaunchDarklyFlags } from 'utils/Hooks/LaunchDarkly/launchDarklyFlags';

const LazyPartnerApiKeysPage = React.lazy(() => import('./Pages'));

const partnerApiKeysConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:partnerApiKeys.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.partnerApiKeys.title',
            url: '/partner-api-keys',
            Icon: (props: IconProps) => <RiKey2Line size={22} {...props} />,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyPartnerApiKeysPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        // Visibility is governed entirely by `visibilityRule`. See `docs/feature-visibility.md`.
        isGloballyAccessible: true,
        permissions: [],
    },
    disableFeature: [],
    visibilityRule: {
        userType: UserType.OwnerOperator,
        permissions: { $all: [UserPermissions.ManagePartnerApiKeys] },
        [LaunchDarklyFlags.PartnerApiKeys]: true,
    },
};

export default partnerApiKeysConfiguration;
